import { render, staticRenderFns } from "./jurisdictManage.vue?vue&type=template&id=441f81ce&scoped=true"
import script from "./jurisdictManage.vue?vue&type=script&lang=js"
export * from "./jurisdictManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f81ce",
  null
  
)

export default component.exports